import FetchHelpers from '../../utils/FetchHelpers';
import formUrl from '../../utils/routes';
import { decamelize } from '../../utils/keysConverter';

export default {
  getTransactionsData(params) {
    const url = formUrl('/api/v1/admin/report/transactions_data');

    return FetchHelpers.get(url, decamelize(params));
  },

  getCashbacksData(params) {
    const url = formUrl('/api/v1/admin/report/cashbacks_data');

    return FetchHelpers.get(url, decamelize(params));
  },
};
